const urls = {
  configuration: "/network-discovery/configuration",
  index: "/network-discovery",
  legacyIndex: "/dashboard",
  legacyConfiguration: "/dashboard/configuration",
};

export default urls;
